import { asSingleStyleConfig } from '../../../../utils/theme';
var baseStyle = {
  alignItems: 'center',
  px: 6,
  py: 4,
  _odd: {
    background: 'white'
  },
  _even: {
    background: 'grey.100'
  },
  '&:not(:last-of-type)': {
    borderBottom: '1px solid #EAEAEA'
  },
  span: {
    lineHeight: 'base'
  }
};
export var ListItemRow = asSingleStyleConfig({
  baseStyle
});